import React, { useState, useEffect } from 'react';
import ModalBase from '../../Controls/ModalBase';
import { recuperarPinMiIosper } from '../../../../services/Auth/Autenticacion';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';

const SeleccionarContacto = React.forwardRef((props, ref) => {
  const { open, setOpen, contactos, onClose, username } = props;

  const [value, setValue] = useState(null);
  const [correo, setCorreo] = useState(null);
  const [loading, setLoading] = useState(false);

  const emails =
    contactos != null
      ? contactos.map((item) => {
          return (
            <FormControlLabel
              key={`contacto-${item.idHistorialContactoPersonaFisica}`}
              value={item.idHistorialContactoPersonaFisica}
              control={<Radio />}
              label={item.descripcion}
            />
          );
        })
      : null;

  const find = (id) => {
    for (let i = 0; i < contactos.length; i++) {
      if (contactos[i].idHistorialContactoPersonaFisica === id) {
        return contactos[i];
      }
    }
  };

  const restablecerHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await recuperarPinMiIosper(username, value);
      setLoading(false);
      onClose(correo);
    } catch (e) {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setValue(parseInt(e.target.value));
    var correo = find(e.target.value);
    setCorreo(correo);
  };

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    if (contactos !== undefined && contactos !== null) {
      setCorreo(contactos[0]);
      setValue(contactos[0].idHistorialContactoPersonaFisica);
    }
  }, [contactos]);

  const form = (
    <div>
      <Grid container spacing={3} direction='column' pb={2}>
        <Grid item>
          <Typography align='center' variant='body2'>
            Verificá el correo seleccionado al que enviaremos los pasos para restablecer tu
            contraseña
          </Typography>
        </Grid>
        <Grid item>
          <Grid
            container
            spacing={3}
            direction='column'
            justifyContent='center'
            alignItems='center'
          >
            <Grid item>
              <FormControl component='fieldset'>
                <RadioGroup
                  size='small'
                  color='primary'
                  name='controlled-radio-buttons-group'
                  value={value}
                  onChange={handleChange}
                >
                  {emails}
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Grid item sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', gap: 2}}>
          <LoadingButton
            variant='contained'
            color='primary'
            disabled={false}
            size='medium'
            loading={loading}
            onClick={(e) => restablecerHandler(e)}
            sx={{ width: { xs: '100%', sm: 'auto' } }}
          >
            Restablecer
          </LoadingButton>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <ModalBase
        open={open}
        setOpen={setOpen}
        content={form}
        title='Restablecer contraseña'
        onClose={handleClose}
      />
    </Box>
  );
});

export default SeleccionarContacto;
